import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

import {
  Box,
  Button,
  Heading,
  Image,
  Size,
  Stack,
} from "@noom/wax-component-library";

import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { useAppContext } from "@/contexts";
import { useRecordRetriageOutcome } from "@/hooks";

import { BaseOutline } from "../core";

const QUESTION_ID = "retriageKeepPlan";

const RetriageKeepPlanConfirmation: React.FC<QuestionComponentProps> = ({
  onClickNext,
}) => {
  const { retriageEligibility: { accessCode } = {} } = useAppContext();
  const { t } = useTranslation();
  const { recordRetriageOutcome, waitForRetriageOutcome } =
    useRecordRetriageOutcome();
  const [isLeaving, setIsLeaving] = useState(false);

  const onClickReturnToApp = async () => {
    setIsLeaving(true);
    await waitForRetriageOutcome();
    onClickNext(null);
    setIsLeaving(false);
  };

  useEffect(() => {
    if (!accessCode) {
      return;
    }
    recordRetriageOutcome(accessCode, "KEPT_SAME_OFFERING");
  }, [accessCode]);

  return (
    <BaseOutline>
      <Stack
        alignItems="center"
        pt={{ base: "40px", md: "100px" }}
        gap={{ base: "30px", md: "50px" }}
      >
        <Image alt="" src="/assets/img/small-checkmark.svg" width="140px" />
        <Heading textAlign="center" size={Size.lg}>
          {t("retriageKeepPlanConfirmation.title")}
        </Heading>

        {isMobile && (
          <Box>
            <Button
              colorScheme="primary"
              isLoading={isLeaving}
              onClick={onClickReturnToApp}
              size="md"
              whiteSpace="unset"
            >
              {t("common.returnToApp")}
            </Button>
          </Box>
        )}
      </Stack>
    </BaseOutline>
  );
};

export const Q_RETRIAGE_KEEP_PLAN: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: ({ selectedProgram }) => selectedProgram === null,
  component: RetriageKeepPlanConfirmation,
};
